import { Fragment, useEffect, useState } from "react";
import Toast from "./Toast";
import Noauth from "./Noauth";
import { isIphonex } from "@/utils";

const isStandalone = () =>
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

const isIosSafari = () => {
    const { userAgent } = window.navigator;
    const isIos = /iphone|ipad|ipod/i.test(userAgent);
    return (
        isIos &&
        /safari/i.test(userAgent) &&
        !/crios|fxios|edgios/i.test(userAgent)
    );
};

const InstallApp = () => {
    const [installPrompt, setInstallPrompt] = useState(null);
    const [showIosHelp, setShowIosHelp] = useState(false);
    const iosInstallAvailable = isIosSafari() && !isStandalone();

    useEffect(() => {
        const handleInstallPrompt = (event) => {
            event.preventDefault();
            setInstallPrompt(event);
        };
        const handleInstalled = () => setInstallPrompt(null);

        window.addEventListener("beforeinstallprompt", handleInstallPrompt);
        window.addEventListener("appinstalled", handleInstalled);
        return () => {
            window.removeEventListener(
                "beforeinstallprompt",
                handleInstallPrompt,
            );
            window.removeEventListener("appinstalled", handleInstalled);
        };
    }, []);

    const handleInstall = async () => {
        if (!installPrompt) return;
        await installPrompt.prompt();
        await installPrompt.userChoice;
        setInstallPrompt(null);
    };

    if (!installPrompt && !iosInstallAvailable) return null;

    return (
        <div className="install-entry">
            {installPrompt ? (
                <button type="button" onClick={handleInstall}>
                    安装应用
                </button>
            ) : (
                <button type="button" onClick={() => setShowIosHelp(true)}>
                    添加到主屏幕
                </button>
            )}
            {showIosHelp && (
                <div className="install-help" role="dialog" aria-modal="true">
                    <div>
                        <strong>添加到主屏幕</strong>
                        <p>点击 Safari 的分享按钮，再选择“添加到主屏幕”。</p>
                        <button
                            type="button"
                            onClick={() => setShowIosHelp(false)}
                        >
                            知道了
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

const Footer = (props) => {
    const { nopeAuth, sword } = props;
    const handleClear = () => {
        if (window.confirm("清除所有本地存储？")) {
            window.localStorage.clear();
            console.warn("清除完毕");
        }
    };

    return (
        <Fragment>
            <footer className={`${isIphonex() ? "iphoneX footer" : "footer"}`}>
                <p>
                    &copy; <span onClick={() => handleClear()}>2017</span> Build
                    with <em>♥</em>, by{" "}
                    <a href="https://note.eyan.life/about">Hoan</a>.
                </p>
            </footer>
            <Toast />
            <Noauth nopeAuth={nopeAuth} sword={sword} />
            <InstallApp />
        </Fragment>
    );
};

export default Footer;
